import { render, staticRenderFns } from "./Declare.vue?vue&type=template&id=6e554cd4&scoped=true&"
import script from "./Declare.vue?vue&type=script&lang=js&"
export * from "./Declare.vue?vue&type=script&lang=js&"
import style0 from "./Declare.vue?vue&type=style&index=0&id=6e554cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e554cd4",
  null
  
)

export default component.exports